/*
 * Created by Tigran Yengibaryan
 * Created on 11/06/2021 09:46
 *
 * Copyright (c) 2021 PicsArt.Inc
 */

import { useRecoilState, useRecoilValue } from 'recoil';
import { applicationView, backgroundStep, backgroundType } from '../models';
import { HomePage } from './HomePage';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { useMemo } from 'react';
import { BackgroundStyle } from './BackgroundStyle';
import { CategorySelection } from './CategorySelection';
import { Palettes } from './Palettes';
import { StickerArrangement } from './StickerArrangementResult';

export const BackgroundEditor = () => {
  const [step, setStep] = useRecoilState(backgroundStep);
  const [, setView] = useRecoilState(applicationView);
  const selectedType = useRecoilValue(backgroundType);
  // const selectedCategory = useRecoilValue(backgroundType);

  const handleStepNext = useMemo(() => {
    switch (step) {
      case 'home':
        return () => setStep('type');
      case 'type':
        return () => setStep('category');
      case 'category':
        return () => setStep('palette');
    }
  }, [setStep, setView, step]);

  const handleStepBack = useMemo(() => {
    switch (step) {
      case 'home':
        console.log('home');
        return () => setView(undefined);
      case 'type':
        return () => setStep('home');
      case 'category':
        return () => setStep('type');
      case 'palette':
        return () => setStep('category');
    }
  }, [setStep, setView, step]);

  const isNextDisabled = () => {
    switch (step) {
      case 'type':
        return selectedType === undefined;
      default:
        return undefined;
    }
  };

  return (
    <>
      <Header />
      <div>
        {step === 'home' && <HomePage />}
        {step === 'type' && <BackgroundStyle />}
        {step === 'category' && <CategorySelection />}
        {step === 'palette' && selectedType === 'pattern' && <Palettes />}
        {step === 'palette' && selectedType === 'sticker' && <StickerArrangement />}
      </div>
      {step !== 'palette' && (
        <Footer onBack={handleStepBack} onNext={handleStepNext} nextDisabled={isNextDisabled()} />
      )}
    </>
  );
};
